var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"example"},[_c('MyCanvas',{attrs:{"radius":_vm.radius}}),_vm._v(" "),_c('p',[_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.radius),expression:"radius",modifiers:{"number":true}}],attrs:{"type":"range","min":"0","max":"100"},domProps:{"value":(_vm.radius)},on:{"__r":function($event){_vm.radius=_vm._n($event.target.value)},"blur":function($event){return _vm.$forceUpdate()}}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/Radius.vue?vue&type=template&id=243a6900&
// module id = null
// module chunks = 